

import {
  FaCogs,
  FaHandshake,
  FaInfoCircle,
  FaPen,
  FaQuestionCircle,
  FaUserSecret,
} from "react-icons/fa";
import {
  FaCartShopping,
  FaUserPlus,
} from "react-icons/fa6";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import { Link } from "react-router-dom";
import LogOut from "../../ui/logout";



export default  function DashboardDetail() {
  
    const user = getCurrentUser();
  const page = "/admin/";
  const admin_pages: any[] = [
    {
      path: "about",
      title: "About Us",
      icon: <FaInfoCircle />,
    },
    {
      path: "products",
      title: "Products",
      icon: <FaCartShopping />,
    },
    {
      path: "privacy-policy",
      title: "Privacy Policy",
      icon: <FaUserSecret />,
    },
    {
      path: "terms",
      title: "Terms & Conditions",
      icon: <FaHandshake />,
    },
    {
      path: "faq",
      title: "FAQ",
      icon: <FaQuestionCircle />,
    },
    {
      path: "change-password",
      title: "Change Password",
      icon: <FaCogs />,
    },
  ];
  return (
    <>
      <div className="dashboard-container">
        <div className="list">
          {admin_pages.map((item: any, index) => (
            <Link
              to={`${page}${item.path}`}
              className="list-item br-5 flex flex-row align-items-center"
              key={item.path}
            >
              <span className="p0" style={{ fontSize: "25px" }}>
                {item.icon}
              </span>
              <span className="spacer ml10">{item.title}</span>
              <span className="p0">
                <FaPen />
              </span>
            </Link>
          ))}
          {user?.role==="admin" && (
            <Link
              to={`/admin/accounts`}
              className="list-item br-5 flex flex-row align-items-center"
            >
              <span className="p0" style={{ fontSize: "25px" }}>
        <FaUserPlus/>
              </span>
              <span className="spacer ml10">Accounts</span>
              <span className="p0">
                <FaPen />
              </span>
            </Link>
          )}
          <LogOut class_name="list-item br-5 flex flex-row align-items-center" />
        </div>
      </div>
    </>
  );
}
